module.exports = __webpack_public_path__ + "static/media/ofertas-ico.8730fc64.svg";